module.exports = __webpack_public_path__ + "static/media/what-new-banner-mobile.b3861a0a.jpg";